import * as types from '../actions/action-types';

const initialState = {
  rooms: [],

  fetchingRooms: false,
  fetchedRooms: false,
  errorFetchingRooms: null,

  createdRoom: null,
  isCreatingRoom: false,
  errorCreatingRoom: null,

  isUpdatingRoom: false,
  errorUpdatingRoom: null,

  invitedToRoom: null,
  invitingToRoom: false,
  errorInvitingToRoom: null
};

export default (state = initialState, action) => {
  switch(action.type) {
    case types.ROOMS_REQUEST_LIST_FULFILLED:
      return {
        ...state,
        fetchingRooms: false,
        fetchedRooms: true,
        errorFetchingRooms: null,
        rooms: action.payload
      };

    case types.ROOMS_REQUEST_LIST_PENDING:
      return {
        ...state,
        fetchingRooms: true,
        fetchedRooms: false,
        errorFetchingRooms: null
      };

    case types.ROOMS_REQUEST_LIST_REJECTED:
      return {
        ...state,
        fetchingRooms: false,
        fetchedRooms: false,
        errorFetchingRooms: action.payload
      };

    case types.ROOMS_CREATE_ROOM_FULFILLED:
      return {
        ...state,
        createdRoom: action.payload.room,
        isCreatingRoom: false,
        errorCreatingRoom: null
      };

    case types.ROOMS_CREATE_ROOM_PENDING:
      return {
        ...state,
        isCreatingRoom: true,
        errorCreatingRoom: null
      };

    case types.ROOMS_CREATE_ROOM_REJECTED:
      return {
        ...state,
        isCreatingRoom: false,
        errorCreatingRoom: action.payload
      };

    case types.ROOMS_UPDATE_ROOM_FULFILLED:
      let updatedRoom = action.payload;

      // Replace the room in the store with the newly updated details.
      let newRooms = state.rooms.map((room) => {
        if (updatedRoom.id === room.id) {
          return updatedRoom;
        } else {
          return room;
        }
      });

      return {
        ...state,
        rooms: newRooms,
        isUpdatingRoom: false,
        errorUpdatingRoom: null
      };

    case types.ROOMS_UPDATE_ROOM_PENDING:
      return {
        ...state,
        isUpdatingRoom: true,
        errorUpdatingRoom: null
      };

    case types.ROOMS_UPDATE_ROOM_REJECTED:
      return {
        ...state,
        isUpdatingRoom: false,
        errorUpdatingRoom: action.payload
      };

    case types.ROOMS_DELETE_ROOM_FULFILLED:
      let id = action.meta.room;

      // Remove the old room from the store.
      let rooms = state.rooms.filter((room) => room.id !== id);

      return {
        ...state,
        rooms,
        isDeletingRoom: false,
        errorDeletingRoom: null
      };

    case types.ROOMS_DELETE_ROOM_PENDING:
      return {
        ...state,
        isDeletingRoom: true,
        errorDeletingRoom: null
      };

    case types.ROOMS_DELETE_ROOM_REJECTED:
      return {
        ...state,
        isDeletingRoom: false,
        errorDeletingRoom: action.payload
      };

    case types.ROOMS_INVITE_USERS_FULFILLED:
      return {
        ...state,
        invitedToRoom: action.payload,
        invitingToRoom: false,
        errorInvitingToRoom: null
      };

    case types.ROOMS_CLEAR_INVITE_USERS:
      return {
        ...state,
        invitedToRoom: null,
        invitingToRoom: false,
        errorInvitingToRoom: null
      };

    case types.ROOMS_INVITE_USERS_PENDING:
      return {
        ...state,
        invitingToRoom: true,
        errorInvitingToRoom: null
      };

    case types.ROOMS_INVITE_USERS_REJECTED:
      return {
        ...state,
        invitingToRoom: false,
        errorInvitingToRoom: action.payload
      };

    case types.ROOMS_CLEAR_CREATED_ROOM:
      return {
        ...state,
        createdRoom: null
      };

    case types.ROOMS_JOIN_ROOM:
      return {
        ...state,
        joinedRoom: action.room
      };

    case types.ROOMS_REQUEST_REMOVE_MEMBERS_PENDING:
      return {
        ...state,
        removingMembers: action.meta.users,
        errorRemovingMembers: null
      };

    case types.ROOMS_REQUEST_REMOVE_MEMBERS_FULFILLED:
      let _updatedRoom = action.payload.room;

      // Replace the room in the store with the newly updated details.
      let _newRooms = state.rooms.map((room) => {
        if (_updatedRoom.id === room.id) {
          return _updatedRoom;
        } else {
          return room;
        }
      });

      return {
        ...state,
        removingMembers: false,
        errorRemovingMembers: null,
        rooms: _newRooms
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/rooms-reducer.js